export default {"src":"__ASTRO_ASSET_IMAGE__DT2$L2od__","width":750,"height":500,"format":"svg"}